export default "__VITE_ASSET__gbSYz$hA__"